/**
 * @generated SignedSource<<cbe05cfda180f0ed9244393f0b56913b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgendaBuilderTone = "CASUAL" | "FORMAL" | "NEUTRAL";
export type agendaBuilderSetToneAndContextMutation$variables = {
  context: string;
  streamId: string;
  tone: AgendaBuilderTone;
};
export type agendaBuilderSetToneAndContextMutation$data = {
  readonly noteStreamSetAgendaBuilderToneAndContext: {
    readonly stream: {
      readonly agendaBuilderContext: string;
      readonly agendaBuilderTone: AgendaBuilderTone;
      readonly id: string;
    };
  } | null;
};
export type agendaBuilderSetToneAndContextMutation = {
  response: agendaBuilderSetToneAndContextMutation$data;
  variables: agendaBuilderSetToneAndContextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tone"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "context",
        "variableName": "context"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "tone",
        "variableName": "tone"
      }
    ],
    "concreteType": "NoteStreamSetAgendaBuilderToneAndContext",
    "kind": "LinkedField",
    "name": "noteStreamSetAgendaBuilderToneAndContext",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agendaBuilderTone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agendaBuilderContext",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agendaBuilderSetToneAndContextMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "agendaBuilderSetToneAndContextMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "dcebdfe79177fa3c7d7cce9d1ae16192",
    "id": null,
    "metadata": {},
    "name": "agendaBuilderSetToneAndContextMutation",
    "operationKind": "mutation",
    "text": "mutation agendaBuilderSetToneAndContextMutation(\n  $streamId: ID!\n  $tone: AgendaBuilderTone!\n  $context: String!\n) {\n  noteStreamSetAgendaBuilderToneAndContext(streamId: $streamId, tone: $tone, context: $context) {\n    stream {\n      id\n      agendaBuilderTone\n      agendaBuilderContext\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b65d7fb066cacbfa9d339d28d92412fb";

export default node;
